<mojo-viewbar></mojo-viewbar>
<mojo-page-title [title]="pageTitle$ | async"></mojo-page-title>

<section class="panel full-page-widget mojo-admin-page data-table full-page-scrollable">
  <div class="panel-body">
    <mojo-supplier-other-creditor-profile-table [supplierOtherCreditorProfiles]="supplierOtherCreditorProfiles | async"
                                                [loading]="(supplierProfilesLoading$ | async) || (profileLoading$ | async)"
                                                (onRowClicked)="supplierOtherCreditorSelected($event)"></mojo-supplier-other-creditor-profile-table>
  </div>
</section>

<mojo-supplier-other-creditor-editor [profiles]="profiles$ | async"
                                     (onSaveComplete)="saveComplete($event)"></mojo-supplier-other-creditor-editor>

